var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-fab-transition',[_c('v-btn',{class:_vm.marginTop,attrs:{"color":_vm.color ? _vm.color : _vm.getThemeColor,"dark":"","absolute":"","top":"","right":"","fab":""},on:{"click":function($event){return _vm.$emit('button-clicked')}}},[_c('v-icon',[_vm._v("mdi-plus")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }